import React from "react";
import { inject, observer } from "mobx-react";
import { withRouter } from "react-router-dom";
import { Form } from "@op/opds.opux";
import Login from "./Login";
import Info from "./Info";
import FeedbackHeader from "./FeedbackHeader";
import FeedbackSubject from "./fields/FeedbackSubject";
import SensitiveInfo from "./SensitiveInfo";
import FeedbackText from "./fields/FeedbackText";
import ContactCustomer from "./fields/ContactCustomer";
import ContactMethod from "./fields/ContactMethod";
import ContactDetailsWrapper from "./fields/ContactDetailsWrapper";
import { BUSINESS, TUPAS, UNIDENTIFIED } from "../../utils/enums";
import ContactReachability from "./fields/ContactReachability";
import ContactPhone, { ContactPhoneNoAnimation } from "./fields/ContactPhone";
import ContactEmail from "./fields/ContactEmail";
import CustomerInfo from "./fields/CustomerInfo";
import CustomerInfoWrapper from "./fields/CustomerInfoWrapper";
import CustomerName from "./fields/CustomerName";
import CustomerAddress from "./fields/CustomerAddress";
import CustomerPostalCode from "./fields/CustomerPostalCode";
import FormError from "./FormError";
import Actions from "./Actions";
import { useMessageGetter } from "react-message-context";
import ErrorSummary from "./ErrorSummary";
import FeedbackTarget from "./fields/FeedbackTarget";
import ContinueSessionModal from "./ContinueSessionModal";
import DataDeletedModal from "./DataDeletedModal";

const Content = observer(({ RestStore, FeedbackStore, history }) => {
  const { customerType, customership, showError, isSending, sendFeedback } =
    RestStore;
  const {
    feedback,
    showContactDetails,
    contactByPhone,
    isDirty,
    displayErrorSummary,
    showErrorSummary,
  } = FeedbackStore;

  const urlMsgs = useMessageGetter("url");
  const formMsgs = useMessageGetter("feedback.form");

  const handleSendFeedback = (callback) => {
    if (FeedbackStore.isInvalid) {
      displayErrorSummary(formMsgs);
      callback();
    } else {
      sendFeedback(feedback, callback, redirect);
    }
  };

  const redirect = (success) => {
    return history.push(urlMsgs(`${success ? "thanks" : "error"}`));
  };

  return (
    <>
      {showErrorSummary && <ErrorSummary />}
      <Login customerType={customerType} />
      <FeedbackHeader />
      <Form method="post" noValidate autoComplete="on">
        <FeedbackTarget />
        <FeedbackSubject />
        <Info customerType={customerType} />
        <SensitiveInfo customerType={customerType} />
        <FeedbackText />
        <ContactCustomer />
        <ContactMethod
          customerType={customerType}
          mount={feedback.contactCustomer.value}
        />
        <ContactDetailsWrapper mount={showContactDetails}>
          {[TUPAS, UNIDENTIFIED].includes(customerType) ? (
            <ContactPhoneNoAnimation />
          ) : (
            <ContactPhone mount={contactByPhone} />
          )}
          <ContactReachability
            mount={contactByPhone && customership === BUSINESS}
          />
          <ContactEmail />
        </ContactDetailsWrapper>
        {customerType === UNIDENTIFIED && <CustomerInfo />}
        <CustomerInfoWrapper mount={feedback.customerInfo.value}>
          <CustomerName />
          <CustomerAddress />
          <CustomerPostalCode />
        </CustomerInfoWrapper>
        {showError && <FormError mount={showError} />}
        <Actions
          isSending={isSending}
          isDirty={isDirty}
          handleSendFeedback={handleSendFeedback}
        />
      </Form>
      <ContinueSessionModal />
      <DataDeletedModal />
    </>
  );
});

export default withRouter(inject("RestStore", "FeedbackStore")(Content));
